{
  "errors": {
    "failedToLoad": "Omien tietojen lataaminen epäonnistui",
    "unexpectedError": "Tapahtui odottamaton virhe",
    "updateFailed": "Yhteystietojen päivittäminen epäonnistui. Yritä myöhemmin uudelleen."
  },
  "contractDocument": {
    "header": "Sopimus",
    "errors": {
      "failedToOpen": "Sopimusdokumentin avaaminen epäonnistui. Yritä myöhemmin uudelleen."
    }
  }
}
